(function () {
  var whatsappNumber = '8618011987603';

  function titleText() {
    var h1 = document.querySelector('h1');
    return (h1 && h1.textContent ? h1.textContent : document.title || 'BOCH auto parts').trim();
  }

  function whatsAppUrl() {
    var text = 'Hello BOCH, I want to request a quote for: ' + titleText() + '. Please confirm fitment, material, quantity, destination and freight.';
    return 'https://wa.me/' + whatsappNumber + '?text=' + encodeURIComponent(text);
  }

  function buildInquiryPanel() {
    var panel = document.createElement('section');
    panel.className = 'boch-inquiry-cta';
    panel.innerHTML = [
      '<p class="boch-inquiry-cta__eyebrow">Inquiry product</p>',
      '<h3>Request a fitment and freight quote</h3>',
      '<p>BOCH supplies bulky exterior upgrade parts for professional projects. Please confirm model year, body style, material, quantity and destination before order. Product price is for reference; international freight, duties, taxes and installation are quoted separately.</p>',
      '<div class="boch-inquiry-cta__actions">',
      '<a class="boch-inquiry-cta__button" target="_blank" rel="noopener" href="' + whatsAppUrl() + '">Request Quote on WhatsApp</a>',
      '<a class="boch-inquiry-cta__button boch-inquiry-cta__button--secondary" href="/pages/contact">Send Inquiry</a>',
      '</div>'
    ].join('');
    return panel;
  }

  function insertProductInquiryPanel() {
    if (!document.querySelector('form[action*="/cart/add"], product-form-component, .shopify-product-form')) return;
    if (document.querySelector('.boch-inquiry-cta')) return;
    var anchor = document.querySelector('product-form-component') ||
      document.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('.shopify-product-form') ||
      document.querySelector('[data-product-form]');
    if (!anchor || !anchor.parentNode) return;
    anchor.parentNode.insertBefore(buildInquiryPanel(), anchor.nextSibling);
  }

  function insertReferenceNote() {
    if (document.querySelector('.boch-reference-note')) return;
    var price = document.querySelector('price-list, .price, [data-price], .product__price');
    if (!price || !price.parentNode) return;
    var note = document.createElement('div');
    note.className = 'boch-reference-note';
    note.textContent = 'Reference price only. Final quotation depends on model fitment, material, quantity, packing and international freight.';
    price.parentNode.insertBefore(note, price.nextSibling);
  }

  function blockCartForms() {
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (form && form.matches && form.matches('form[action*="/cart/add"], form[action="/cart"]')) {
        event.preventDefault();
        window.open(whatsAppUrl(), '_blank', 'noopener');
      }
    }, true);
  }

  function decorateCartPage() {
    if (!/^\/cart\/?$/.test(window.location.pathname)) return;
    if (document.querySelector('.boch-cart-inquiry')) return;
    var main = document.querySelector('main') || document.body;
    var panel = document.createElement('section');
    panel.className = 'boch-cart-inquiry';
    panel.innerHTML = [
      '<h1>Request a BOCH quotation</h1>',
      '<p>For body kits, bumpers, headlights and carbon fiber parts, BOCH confirms fitment and freight before order. Please send your model year, product photos or links, quantity and destination.</p>',
      '<p><a class="boch-inquiry-cta__button" target="_blank" rel="noopener" href="' + whatsAppUrl() + '">Request Quote on WhatsApp</a></p>'
    ].join('');
    main.prepend(panel);
  }

  function init() {
    insertProductInquiryPanel();
    insertReferenceNote();
    decorateCartPage();
  }

  blockCartForms();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
